import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    padding: 16,
    backgroundColor: "#FFFFFF",
  }
})(Box)